<script lang="jsx">
import { mapGetters, mapActions, mapMutations } from 'vuex'
import List from '../../components/List'
import InlineForm from '../../components/InlineForm'
import DropDown from '../../components/DropDown.vue'
import Pagination from '../../components/metapic/page/Pagination'

const SpinnerView = () => (
  <div class="spinner-container">
    <div class="spinner" />
  </div>
)

const ClientList = ({ context, clients }) => (
  <div>
    {clients && clients.length ? (
      <List
        items={clients}
        keys={{
          title: 'name',
          meta: [
            { label: 'ID', path: 'id' },
            { label: 'Feed', path: 'feed' },
            { label: 'Client ID', path: 'clientId' },
            { label: 'Revenue Share', path: 'revenue.share' },
            { label: 'Tiers', path: 'revenue.tiers.name' },
            {
              label: 'Store Group',
              getter: (client) => context.groupName(client.storeGroup),
            },
          ],
        }}
        footer={(item) => (
          <div>
            <router-link class="button" to={`/clients/${item.id}/edit`}>
              <edit-icon /> <span>Edit</span>
            </router-link>
            <router-link class="button" to={`/clients/${item.id}/users`}>
              <settings-icon /> <span>Permissions</span>
            </router-link>
          </div>
        )}
      />
    ) : (
      <div>No clients with this search parameters</div>
    )}
  </div>
)

export default {
  computed: {
    ...mapGetters('clients', ['clientsPerPage', 'clients', 'clientsLoading', 'clientsError', 'pagination', 'term', 'group', 'groupName']),
    ...mapGetters('storeGroups', ['storeGroups']),
  },
  created() {
    if (!this.storeGroups.length) {
      this.fetch()
    }
    this.fetchClients()
  },
  methods: {
    ...mapMutations('clients', ['update']),
    ...mapActions('clients', ['fetchClients']),
    ...mapActions('storeGroups', ['fetch']),
    submitHandler(e) {
      e.preventDefault()
      this.fetchClients()
    },
  },

  render() {
    return (
      <div class="page page-content-wrapper">
        <InlineForm submit={this.submitHandler}>
          <div>
            <label for="store-search-term">Term:</label>
            <div class="icon-input">
              <input
                id="store-search-term"
                placeholder="E.g. nouw or devote"
                autofocus={true}
                type="search"
                value={this.term}
                onInput={(e) => this.update({ path: 'term', value: e.target.value })}
              />
              <search-icon />
            </div>
          </div>
          <DropDown
            id="client-group-filter"
            label="Group"
            value={this.group}
            update={(val) =>
              this.update({
                path: 'group',
                value: val,
              })
            }
            default=""
            items={this.storeGroups}
          />
          <button type="submit">Search</button>
        </InlineForm>

        <div class="page-content">
          {this.clientsLoading && <SpinnerView />}
          {this.clientsError && <p>Something went wrong!</p>}
          {this.clients !== null && !this.clientsLoading && <ClientList context={this} clients={this.clientsPerPage} />}
        </div>

        <Pagination currentPage={this.pagination.current} lastPage={this.pagination.last} onPageChange={this.fetchClients} />
      </div>
    )
  },
}
</script>
